import React, { useRef, useEffect, useState } from 'react';
import { BsFillForwardFill } from 'react-icons/bs';
import CommonHeader from '../../../common/commonComponents/commonHeader/commonHeader';
import { endpoint } from '../../../common/constant';

import {
	Container,
	Card,
	CardBody,
	CardHeader,
	Button,
	Row,
	Col,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import ListComponent from './ListComponent';
import { getDropdownData } from './common';
import AButton from '../../../common/form-fields-mui/AButton';
import { fetchAllPromisedData , fetchAllPostPromisedData} from '../../../common/utils/methods/commonMethods/utilityMethod';
import { concessionServiceBaseUrl, masterServiceBaseUrl } from '../../../../../../services/http';
import CustomLoader from '../../../common/commonComponents/Loader/loader';
import {getDispValForReactSelectByOneID} from '../../../common/utils/methods/commonMethods/utilityMethod';
import { successToast } from '../../../common/utils/methods/toasterFunctions/function';
import { getIdsArray } from '../../../edpOps/constant/common';

const ProcessAndRoleMapping = (props) => {

    const { id } = props.match.params;

    const history = useHistory();
    const ref = useRef();
    const [loading , setLoading] = useState(false);
    const [allActiveProcess, setAllActiveProcess] = useState(null);
    const [allActiveRoles, setAllActiveRoles] = useState(null);
    const [paymentModeData, setPaymentModeData] = useState(null);
    const [groupCodeList, setGroupCodeList] = useState(null);
	const [companyCodeList, setCompanyCodeList] = useState(null);

    const getPaymentMode = async (activeProcesses = allActiveProcess, activeRoles = allActiveRoles) => {
        try{
            setLoading(true);
            const resp = await fetchAllPromisedData(`${concessionServiceBaseUrl}/paymentMode/getPaymentMode/${id}?requireMapping=true`, true);
            if(resp?.code === 200){
             setPaymentModeData({
                ...resp?.data,
                processAndRoleMappingData : resp?.data?.paymentModeProcessTagTypeMappingDTOS?.map(el=>
                ({...el,
                processType : activeProcesses?.find(process => process.value === el?.processTagTypeMasterId),
                roles : el?.processTagTypeRoleMappingDTOS?.map(el => activeRoles?.find(role => role?.value === el?.roleId))
                })
                )
             });
            }

        }catch(err){
            console.error(err);
        }finally{
            setLoading(false);
        }
    }

    const createUpdateHandler = async (rowForm) => {
        try {
            setLoading(true);
            const reqObj = {
                status : rowForm?.status,
                paymentModeId:id,
                processTagTypeMasterId : rowForm?.processType?.value,
                processTagTypeDisplayValue : rowForm?.processType?.label,
                roleIds : getIdsArray(rowForm?.roles),
            //     processTagTypeRoleMappingDTOS : rowForm?.roles?.map(role => ({
            //           "paymentModeMasterId":id,
            // "processTagTypeMasterId": rowForm?.processType?.value,
            // "roleId": role?.value
            //     })),
            }
            let url = `${endpoint.paymentMode.processAndRoleMapping.create}`;
            let method = 'post';

            if (!rowForm?.isNew) {
                url = `${endpoint.paymentMode.processAndRoleMapping.update}`;
                method = 'put'
            }
            const resp = await fetchAllPostPromisedData(url, reqObj, method);
            if (resp?.code === 200) {
                getPaymentMode();
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (err) {
            console.log(err);
        }finally{
            setLoading(false);
        }
    }
 

    useEffect(()=>{
        if(allActiveProcess && allActiveRoles && groupCodeList && companyCodeList){
            getPaymentMode();
        } 
    },[id])

    useEffect(()=>{
      init();
    },[]);
    
    const init = async() => {
        const [allActiveProcess, allActiveRoles, allGroupCode, allCompanyCode] = await Promise.all([
            getDropdownData(endpoint.process_Tag.getAllActive, "tagTypeDispValue", "id"),
            getDropdownData(endpoint.getRole.allActiveRoles, "roleName", "id"),
            fetchAllPromisedData(`${masterServiceBaseUrl}/groupCode/getAllGroupCode`),
            fetchAllPromisedData(`${masterServiceBaseUrl}/companyCode/getAllCompanyCode`),
        ]);

        setAllActiveProcess(allActiveProcess);
        setAllActiveRoles(allActiveRoles);
        setGroupCodeList(allGroupCode);
        setCompanyCodeList(allCompanyCode);

         getPaymentMode(allActiveProcess, allActiveRoles, allGroupCode, allCompanyCode);
    }

    const headerData = [
		{
			label: 'Business Group',
			value: `${
				paymentModeData &&
				groupCodeList &&
			    groupCodeList?.find(el => el?.id === paymentModeData?.groupCodeId)?.groupCodeDispValue
			}`,
		},
		{
			label: 'Company Code',
			value: `${
				paymentModeData &&
				companyCodeList &&
				companyCodeList?.find(el => el?.id === paymentModeData?.companyCodeId)?.companyCodeDispValue
			}`,
		},
		{
			label: 'Payment Method - Description',
			value: `${paymentModeData && paymentModeData?.paymentModeDispValue} - ${
				paymentModeData && paymentModeData?.paymentModeDesc
			}`,
		},
		{
			label: 'SAP Paymode',
			value: paymentModeData?.sapPaymode,
		},
	];

    return ( 
        <Container className="mt-4" fluid>
        <Card>
            <CardHeader>
                <h2 className="mb-0 floatLeft">
                    <span
                        onClick={() => history.goBack()}
                        style={{ cursor: 'pointer', color: '#11CDEF' }}
                    >
                        Payment Mode
                    </span>
                    &nbsp;
                    {<BsFillForwardFill style={{ fontSize: '30px' }} />}&nbsp;Process & Role Mapping
                </h2>
            </CardHeader>
        </Card>
        {loading ? (
            <div
                className="mx-auto text-center py-5 my-5"
                style={{ height: '100vh' }}
            >
                <CustomLoader
                    apiLoader={loading}
                    loaderHeight={'200px'}
                    loaderWidth={'100%'}
                />
            </div>
        ) : (
            <div>
                <Card>
                    <CardBody>
                        <CommonHeader
                            headerData={headerData}
                            lastUpdatedDate={
                                paymentModeData && paymentModeData['updatedOn']
                            }
                            countLabel={'Total Entries '}
                            countValue={
                                (paymentModeData && paymentModeData['totalReceiptCount']) ||
                                '00'
                            }
                        />
                    </CardBody>
                </Card>
                        </div>
        )}
         <Card>
            <CardHeader>
                            <AButton
                            variant = "primary_filled"
                            className = "float-right"
                            size = "xs"
                            onClick={() => ref.current.addNewRow()}
                            >
                                + Add Mapping
                            </AButton>
            </CardHeader>
                    <CardBody>
                    <ListComponent
                    rows={paymentModeData?.processAndRoleMappingData ?? []}
                    ref={ref}
                    allActiveProcess={allActiveProcess}
                    rolesDropdown={allActiveRoles}
                    // businessAreaDropdown={allActiveBusinessAreas}
                    createUpdateHandler={createUpdateHandler}
                    loading={loading}
                    // currentPage={paginationInfo.currentPage}
                    // totalRecords={paginationInfo.totalRecords}
                    // pageChangeHandler={pageChangeHandler}
                />
                        </CardBody>
                        </Card>
        </Container>
     );
}
 
export default ProcessAndRoleMapping;